class SystemConst {
  static API_BASE = 'api'


  static FORMATS_DATE = {
    DD_MM_YYYY: 'DD/MM/YYYY',
    YYYY_MM_DD: 'YYYY-MM-DD',
    YYYY_MM_DD_Z: 'YYYY-MM-DDTHH:mm:ss',
    DD_MM_YYYY_HH_MM_SS: 'DD/MM/YYYY HH:mm:ss',
    HH_MM: 'HH:mm',
  }
  static API_ERROR_CODE = {
    ERR_NETWORK: 'ERR_NETWORK',
  }
  static DATE_TYPE = {
    TODAY: 'TODAY',
    WEEK: 'WEEK',
    MONTH: 'MONTH',
    YEAR: 'YEAR',
  }
}

export default SystemConst
